<script setup lang="ts">
import { defineComponent, ref,reactive,watchEffect } from 'vue'
import { ArrowRight,CaretBottom, SwitchButton } from '@element-plus/icons-vue'
import { ElBreadcrumb, ElBreadcrumbItem,ElAvatar,ElDropdown,ElDropdownItem,ElDropdownMenu,ElIcon, ElMessageBox } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import type { UserInfoType } from '@/stores/user'
import type { ApiResult } from '@/axios'
import {gotoURL} from '@/utils/mfk'

const userStore = useUserStore()
const userInfo:UserInfoType=userStore.getUserInfo
const { currentRoute } = useRouter()
interface IBreadcrumbItem{
  path: string,
  name: string,
  title: string
}
const levelList:IBreadcrumbItem[] = reactive<IBreadcrumbItem[]>([])

const currentPath=ref('')
const stop = watchEffect(() => {
  const matched = currentRoute.value.matched
  currentPath.value = matched.slice(-1)[0].path
  levelList.length=0
  for(let item of matched){
  if(item.path=='/' || item.path==''){
    continue
  }
    levelList.push({
          path:item.path,
          name:item.name?item.name as string:'',
          title:item.meta && item.meta.title?item.meta.title as string:''
        })
    }
})
const goLogout=()=>{
ElMessageBox.confirm('您确定要退出系统吗？', '提示', {
  confirmButtonText: '确定',
  cancelButtonText: '取消',
  type: 'warning'
}).then(() => {
  userStore.reset()
  gotoURL(import.meta.env.VITE_LOGIN_PATH)
}).catch(() => {
  
})
}
const goChangePwd=()=>{
  gotoURL('/user/changePwd')
}
</script>
<template>
  <div class="navbar">
    <el-breadcrumb :key="currentPath" :separator-icon="ArrowRight">
    <el-breadcrumb-item :to="{ path: item.path }" v-for="(item,index) in levelList" :key="index">{{ item.title }}</el-breadcrumb-item>
   </el-breadcrumb> 
  <el-dropdown class="right-container">
    <div class="el-dropdown-link">
      <span class="user-name">{{ userInfo.displayName }}</span>
      <el-avatar shape="square" :src="userInfo.headImgUrl?userInfo.headImgUrl:'/public/logo.png'" />
      <el-icon>
        <CaretBottom />
      </el-icon>
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item @click="goChangePwd">修改密码</el-dropdown-item>
        <el-dropdown-item :icon="SwitchButton" divided @click="goLogout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
  </div>
</template>
<style scoped>
.navbar {
  height: 50px;
  padding-left: 10px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.navbar .right-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 5px;
}
.navbar  .right-container .el-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.navbar  .right-container .el-dropdown-link .el-icon{
  cursor: pointer;
}
.navbar .right-container .el-dropdown-link .user-name {
  margin-right: 10px;
}
</style>